export var InputType;
(function (InputType) {
    InputType["Toggle"] = "toggle";
    InputType["Input"] = "input";
    InputType["Select"] = "select";
    InputType["DoubleSelect"] = "double-select";
    InputType["EditOrgs"] = "edit-orgs";
    InputType["EditOrgsWithToggle"] = "edit-orgs-with-toggle";
})(InputType || (InputType = {}));
//# sourceMappingURL=types.js.map